export default iri => iri.split('/').reverse()[0]
